import { render } from "./SkewBox.vue?vue&type=template&id=2dc78c7d&scoped=true"
import script from "./SkewBox.vue?vue&type=script&lang=js"
export * from "./SkewBox.vue?vue&type=script&lang=js"

import "./SkewBox.vue?vue&type=style&index=0&id=2dc78c7d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dc78c7d"]])

export default __exports__